import { Forecast } from './../../../../../shared/sdk/models/Forecast';
import { PlayerService } from './../../../../../player/services/player.service';
import { GlobalPropertiesService } from './../../../../../core.module/services/global-properties.service';
import { ForecastApi } from './../../../../../shared/sdk/services/custom/Forecast';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { SeWeatherMultidayConfig } from './se-weather-multiday-config.class';
import { IScreenElement } from './../screen-element.interface';
import { ScreenElementClass } from './../screen-element.class';
import { Subject } from 'rxjs/Subject';
import { Component, HostBinding, Injector, Input, OnInit, Output, ViewChild, HostListener, ElementRef, OnDestroy, AfterViewInit, Renderer2 } from '@angular/core';
import { LoggerService } from '../../../../../shared/sdk';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ICustomPropConfig } from '../../prop-editors.moudule/custom-prop-config.interface';


@Component({
  selector: 'app-se-weather-multiday',
  templateUrl: './se-weather-multiday.component.html',
  styleUrls: ['./se-weather-multiday.component.css', './climacon.css', './climacon-styles.css']
})
export class SeWeatherMultidayComponent extends ScreenElementClass implements IScreenElement, OnInit, OnDestroy, AfterViewInit {

  public elementConfig = new SeWeatherMultidayConfig();
  public math = Math;

  public weather: any = {
    city: 'Loading...',
    data: {
      currentDayForecast: {},
      currentConditions: {
        maxTempF: '-',
        maxTempC: 'c',
        humidity: '0%',
        windGustMPH: 0,
        windDir: 'NW',
        feelslikeF: '-',
        feelslikeC: '-',
        windSpeedMPH: '',
        pressureIN: '0',
        place: {
          name: '',
          state: '',
        },
        ob: {
          weatherPrimary: '',
        }
      },
      forecast10Day: {
        forecastday: []
      }

    }
  };
  public dummyForecast = {
    icon: '',
    conditions: '',
    weekday: '',
    weekday_short: '',
    maxTempF: '0',
    maxTempC: '0',
    minTempF: '0',
    minTempC: '0'
  };

  public currentTime = Date.now();
  public currentTimeTimer;
  public weatherUpdateTimer;

  public mainSvg = '';

  constructor(
    public injector: Injector,
    public sanitizer: DomSanitizer,
    public elementRef: ElementRef,
    public renderer: Renderer2,
    public forecastApi: ForecastApi,
    public logger: LoggerService,
    public gps: GlobalPropertiesService
  ) {
    super(sanitizer); // initilize base class
    // get inital configs (if passed by injector)
    const startingElementConfig = this.injector.get('elementConfig');  // get commonConfig Value if injected

    if (startingElementConfig) {
      this.elementConfig.fromJson(startingElementConfig);
    }


    // add 7 dummy days to array to start
    for (let index = 0; index < 6; index++) {
      // this.weather.data.forecast10Day.simpleforecast.forecastday.push(this.dummyForecast);
      this.weather.data.forecast10Day.forecastday.push(this.dummyForecast);
    }

    this.weather.data.currentDayForecast = this.dummyForecast;

    this.mainSvg = 'cloudRainSun'; // starting main icon

  }

  async ngOnInit() {

    await this.updateForecast();
    const fifteenMin = (1000 * 60 * 15);

    // start weather update timer
    this.weatherUpdateTimer = setInterval(async () => {
      await this.updateForecast();
    }, fifteenMin);

    this.currentTimeTimer = setInterval(() => {
      this.currentTime = Date.now();
    }, 1000);
  }

  ngOnDestroy() {
    // Called once, before the instance is destroyed.
    // Add 'implements OnDestroy' to the class.
    if (this.currentTimeTimer) {
      clearInterval(this.currentTimeTimer);
    }

    if (this.weatherUpdateTimer) {
      clearInterval(this.weatherUpdateTimer);
    }
  }

  async ngAfterViewInit() {
    this.onElementReadySubject.next(this);
  }

  getAutoBackgroundImage() {
    if (this.weather && this.weather.data.currentConditions && this.weather.data.currentConditions.place.name && this.weather.data.currentConditions.place.state) {
      const isDay = this.weather.data.currentConditions.ob.isDay;
      let output: string;
      let state: string;
      state = this.weather.data.currentConditions.place.state.toUpperCase();

      if (isDay) {
        output = 'assets/images/weather/day/' + state + ' Day Image.jpg';
      } else {
        output = 'assets/images/weather/night/' + state + ' Night Image.jpg';
      }


      return output;

    } else {
      return 'assets/images/paris-sm.jpg'; // use this as a default
    }
  }

  getCustomProperties() {
    const userAdjustableProps: ICustomPropConfig[] = new Array;
    const weatherProp = {
      type: 'pe-weather',
      name: 'Weather Widget Control',
      propPath: 'elementConfig',
      defaultValue: 0,
      tooltip: 'Edit properties of the weather widget here',
      showDefaultReset: true,
      groupName: null,
      settings: {
        usePlayerZip: {
          type: 'pe-checkbox',
          name: 'Use player Zip',
          propPath: 'elementConfig.usePlayerZip',
          defaultValue: true,
          tooltip: 'Use player zip code when running on a player',
          showDefaultReset: true,
          groupName: null,
          settings: null
        },
        locationCheck: {
          type: 'pe-checkbox',
          name: 'Show Location',
          propPath: 'elementConfig.display.header.showLocation',
          defaultValue: true,
          tooltip: 'Show / Hide Location at top',
          showDefaultReset: true,
          groupName: null,
          settings: null
        },
        datetimeCheck: {
          type: 'pe-checkbox',
          name: 'Show Date & Time',
          propPath: 'elementConfig.display.header.showDatetime',
          defaultValue: true,
          tooltip: 'Show / Hide the Date and Time',
          showDefaultReset: true,
          groupName: null,
          settings: null
        },
        weatherDescCheck: {
          type: 'pe-checkbox',
          name: 'Show Description',
          propPath: 'elementConfig.display.showTextDesc',
          defaultValue: true,
          tooltip: 'Show / Hide the weather description',
          showDefaultReset: true,
          groupName: null,
          settings: null
        },
        descBackgroundColor: {
          type: 'pe-colorpicker',
          name: 'Desc bg Color',
          propPath: 'elementConfig.display.descBackgroundColor',
          defaultValue: 'rgba(0,0,0,.3)',
          tooltip: 'Sets the color of the weather description background color',
          showDefaultReset: true,
          groupName: null,
          settings: {
          }
        },
        weatherIconCheck: {
          type: 'pe-checkbox',
          name: 'Show Main Icon',
          propPath: 'elementConfig.display.showMainIcon',
          defaultValue: true,
          tooltip: 'Show / Hide the main weather icon',
          showDefaultReset: true,
          groupName: null,
          settings: null
        },
        showExtrasCheck: {
          type: 'pe-checkbox',
          name: 'Show Extra Info',
          propPath: 'elementConfig.display.extra.show',
          defaultValue: true,
          tooltip: 'Show / Hide additional weather info like wind speed',
          showDefaultReset: true,
          groupName: null,
          settings: null
        },
        showCurrentRealFeel: {
          type: 'pe-checkbox',
          name: 'Show Real Feel',
          propPath: 'elementConfig.display.current.showRealFeel',
          defaultValue: true,
          tooltip: 'Show / Hide current Real Feel temp',
          showDefaultReset: true,
          groupName: null,
          settings: null
        },
        showCurrentHighLowCheck: {
          type: 'pe-checkbox',
          name: 'Show High/Low',
          propPath: 'elementConfig.display.current.showHighLow',
          defaultValue: true,
          tooltip: 'Show / Hide current day High-Low temp',
          showDefaultReset: true,
          groupName: null,
          settings: null
        },
        daySlider: {
          type: 'pe-slider',
          name: 'Forecast Days',
          propPath: 'elementConfig.display.forecast.numDays',
          defaultValue: 6,
          tooltip: 'Reset to default',
          showDefaultReset: true,
          groupName: null,
          settings: {
            connect: [true, false],
            start: [6],
            step: 1,
            range: {
              min: 0,
              max: 6
            },
            // step: .01,
            tooltips: true,
            orientation: 'horizontal',
          }
        },
        showBackgroundImage: {
          type: 'pe-checkbox',
          name: 'Show Image',
          propPath: 'elementConfig.display.showBackgroundImage',
          defaultValue: true,
          tooltip: 'Show / Hide background Image',
          showDefaultReset: true,
          groupName: null,
          settings: null
        },
        useAutoBackground: {
          type: 'pe-checkbox',
          name: 'Auto Image',
          propPath: 'elementConfig.display.useAutoBackground',
          defaultValue: true,
          tooltip: 'Use automatic image by state',
          showDefaultReset: true,
          groupName: null,
          settings: null
        },
        showBackgroundColor: {
          type: 'pe-checkbox',
          name: 'Background Color',
          propPath: 'elementConfig.display.showBackgroundColor',
          defaultValue: true,
          tooltip: 'Show / Hide Background Color',
          showDefaultReset: true,
          groupName: null,
          settings: {
          }
        },
        backgroundColor: {
          type: 'pe-colorpicker',
          name: 'Background Color',
          propPath: 'elementConfig.display.backgroundColor',
          defaultValue: 'rgba(0,0,0,.3)',
          tooltip: 'Sets the color of the shadow',
          showDefaultReset: true,
          groupName: null,
          settings: {
          }
        },
        fontColor: {
          type: 'pe-colorpicker',
          name: 'Font Color',
          propPath: 'elementConfig.display.fontColor',
          defaultValue: 'rgba(255,2552,255,1)',
          tooltip: 'Sets the color of the shadow',
          showDefaultReset: true,
          groupName: null,
          settings: {
          }


        }

      }
    };

    userAdjustableProps.push(weatherProp);

    return userAdjustableProps;

  }

  getMainHeight(): number {

    let height = 500;

    if (!this.elementConfig.display.forecast.show || !this.elementConfig.display.forecast.numDays) {
      height -= 150;
    }

    if (!this.elementConfig.display.header.showDatetime) {
      height -= 25;
    }

    if (!this.elementConfig.display.header.showLocation) {
      height -= 40;
    }

    return height;
  }

  getMainWidth(): number {

    let width = 770; // starting width

    if (!this.elementConfig.display.showMainIcon) {
      width -= 200;
    }

    if (!this.elementConfig.display.extra.show) {
      width -= 200;
    }

    const minwidth = this.elementConfig.display.forecast.numDays * 110;
    width = minwidth > width ? minwidth : width;

    return width;
  }

  getTopHeight(): number {

    let height = 350;

    if (!this.elementConfig.display.header.showDatetime) {
      height -= 25;
    }

    if (!this.elementConfig.display.header.showLocation) {
      height -= 40;
    }

    return height;
  }

  getScaleX() {
    const originalX = this.getMainWidth() + (this.elementConfig.borderWidth * 2);

    return this.elementConfig.width / originalX;

  }

  getScaleY() {
    const originalY = this.getMainHeight() + (this.elementConfig.borderWidth * 2);

    return this.elementConfig.height / originalY;
  }

  async updateForecast(force?) {
    let zip = this.elementConfig.manualZip;

    if (!this.gps.appGlobal.isDesignerMode && this.elementConfig.usePlayerZip) {
      if (this.gps.appGlobal.currentPlayerZip) {
        zip = this.gps.appGlobal.currentPlayerZip;
      }
    }
    this.weather = await this.getForecast(zip, force);
  }

  async getForecast(zipcode, force?) {
    // try to get from cache
    const forecastCache = localStorage.getItem('weather-' + zipcode);
    let forecast = forecastCache ? JSON.parse(forecastCache) : null;
    const fifteenMin = (60 * 15); // in SECONDS
    const secsSinceLastUpdate = forecast ? moment().unix() - moment(forecast.updatedAt).unix() : null;
    const updateNeeded = forecast ? secsSinceLastUpdate >= fifteenMin : true;



    if (updateNeeded || force) {
      try {
        const result = await this.forecastApi.find({ where: { zip: zipcode } }).toPromise();

        if (result && result.length) {
          forecast = result[0];

          if (forecast.data.forecast10Day.forecastday.length) {
            // get rid of the first day (since that is the current day)
            forecast.data.currentDayForecast = _.clone(forecast.data.forecast10Day.forecastday[0]);
            forecast.data.forecast10Day.forecastday.shift();
          }

          // only keep seven days
          /* while (forecast.data.forecast10Day.length > 7) {
            forecast.data.forecast10Day.simpleforecast.forecastday.pop();
          } */
        }
        localStorage.removeItem('weather-' + zipcode); // clear the cache
        localStorage.setItem('weather-' + zipcode, JSON.stringify(forecast)); // save to cache
      } catch (error) {
        this.logger.error(`Could not get new forecast data from server`, error);
      }

    }

    // set climacons
    if (_.get(forecast, 'data.forecast10Day.forecastday', null)) {
      for (const day of forecast.data.forecast10Day.forecastday) {
        const objClimacon = this.getClimiconString(day.icon, day.isDay);
        day.climacon = objClimacon.climacon;
        day.topBar = objClimacon.topBar;

      }
    }

    if (forecast && forecast.data && forecast.data.currentConditions.ob) {
      const objCI = this.getClimiconString(forecast.data.currentConditions.ob.icon, forecast.data.currentConditions.ob.isDay);
      this.mainSvg = objCI.climacon;
    }

    return forecast;
  }

  getClimiconString(wuIcon: string, isDay: boolean): { climacon: string, aniClimacon: string, topBar: string } {
    const out = { climacon: '', aniClimacon: '', topBar: 'sun' };

    wuIcon = wuIcon.split('.').slice(0, -1).join('.');
    const testStr = wuIcon.split('nt_').join('');

    switch (testStr) {
      case 'blizzard':
        out.climacon = 'snow';
        out.topBar = 'cloud';
        break;
      case 'blowingsnow':
        out.climacon = 'snow';
        out.topBar = 'cloud';
        break;
      case 'clear':
        out.climacon = 'sun';
        out.topBar = 'sun';
        break;
      case 'cloudy':
        out.climacon = 'cloud';
        out.topBar = 'cloud';
        break;
      case 'cloudyw':
        out.climacon = 'cloud';
        out.topBar = 'wind';
        break;
      case 'cold':
        out.climacon = 'cloud';
        out.topBar = 'cloud';
        break;
      case 'drizzle':
        out.climacon = 'drizzle';
        out.topBar = 'drizzle';
        break;
      case 'drizzlef':
        out.climacon = 'drizzle';
        out.topBar = 'sleet';
        break;
      case 'dust':
        out.climacon = 'haze sun';
        out.topBar = 'cloud sun';
        break;
      case 'fair':
        out.climacon = 'sun';
        out.topBar = 'sun';
        break;
      case 'flurries':
        out.climacon = 'flurries';
        out.topBar = 'flurries';
        break;
      case 'flurriesw':
        out.climacon = 'flurries';
        out.topBar = 'flurries';
        break;
      case 'freezingrain':
        out.climacon = 'sleet';
        out.topBar = 'sleet';
        break;
      case 'fog':
        out.climacon = 'fog sun';
        out.topBar = 'cloud sun';
        break;
      case 'hazy':
        out.climacon = 'haze sun';
        out.topBar = 'cloud sun';
        break;
      case 'hot':
        out.climacon = 'sun';
        out.topBar = 'sun';
        break;
      case 'mcloudy':
        out.climacon = 'cloud';
        out.topBar = 'cloud';
        break;
      case 'mcloudyr':
        out.climacon = 'cloud';
        out.topBar = 'cloud rain';
        break;
      case 'mcloudyrw':
        out.climacon = 'cloud';
        out.topBar = 'cloud rain';
        break;
      case 'mcloudyrs':
        out.climacon = 'cloud';
        out.topBar = 'cloud rain';
        break;
      case 'mcloudys':
        out.climacon = 'cloud';
        out.topBar = 'snow';
        break;
      case 'mcloudysf':
        out.climacon = 'cloud';
        out.topBar = 'cloud';
        break;
      case 'mcloudysfw':
        out.climacon = 'cloud';
        out.topBar = 'wind';
        break;
      case 'mcloudysw':
        out.climacon = 'cloud';
        out.topBar = 'wind';
        break;
      case 'mcloudyt':
        out.climacon = 'cloud';
        out.topBar = 'tstorms';
        break;
      case 'mcloudytw':
        out.climacon = 'cloud';
        out.topBar = 'tstorms';
        break;
      case 'mcloudyw':
        out.climacon = 'cloud';
        out.topBar = 'wind';
        break;
      case 'pcloudy':
        out.climacon = 'cloud sun';
        out.topBar = 'cloud sun';
        break;
      case 'pcloudyr':
        out.climacon = 'showers cloud sun';
        out.topBar = 'cloud rain';
        break;
      case 'pcloudyrw':
        out.climacon = 'showers cloud sun';
        out.topBar = 'cloud rain';
        break;
      case 'pcloudys':
        out.climacon = 'cloud sun';
        out.topBar = 'cloud snow';
        break;
      case 'pcloudysf':
        out.climacon = 'cloud sun';
        out.topBar = 'cloud sun';
        break;
      case 'pcloudysfw':
        out.climacon = 'cloud sun';
        out.topBar = 'cloud';
        break;
      case 'pcloudysw':
        out.climacon = 'cloud sun';
        out.topBar = 'cloud sun';
        break;
      case 'pcloudyt':
        out.climacon = 'cloud sun';
        out.topBar = 'storms';
        break;
      case 'pcloudytw':
        out.climacon = 'cloud sun';
        out.topBar = 'storms';
        break;
      case 'pcloudyw':
        out.climacon = 'cloud sun';
        out.topBar = 'cloud sun';
        break;
      case 'rain':
        out.climacon = 'rain';
        out.topBar = 'rain';
        break;
      case 'rainw':
        out.climacon = 'rain';
        out.topBar = 'wind';
        break;
      case 'rainandsnow':
        out.climacon = 'rain';
        out.topBar = 'snow';
        break;
      case 'raintosnow':
        out.climacon = 'rain';
        out.topBar = 'snow';
        break;
      case 'rainw':
        out.climacon = 'rain';
        out.topBar = 'wind';
        break;
      case 'showers':
        out.climacon = 'rain';
        out.topBar = 'showers cloud sun';
        break;
      case 'showersw':
        out.climacon = 'rain';
        out.topBar = 'showers cloud sun';
        break;
      case 'sleet':
        out.climacon = 'sleet';
        out.topBar = 'rain';
        break;
      case 'sleetsnow':
        out.climacon = 'snow';
        out.topBar = 'sleet';
        break;
      case 'smoke':
        out.climacon = 'hazy sun';
        out.topBar = 'cloud sun';
        break;
      case 'snow':
        out.climacon = 'snow';
        out.topBar = 'cloud';
        break;
      case 'snoww':
        out.climacon = 'snow';
        out.topBar = 'wind';
        break;
      case 'snowshowers':
        out.climacon = 'snow';
        out.topBar = 'cloud';
        break;
      case 'snowshowersw':
        out.climacon = 'snow';
        out.topBar = 'wind';
        break;
      case 'snowtorain':
        out.climacon = 'snow';
        out.topBar = 'rain';
        break;
      case 'sunny':
        out.climacon = 'sun';
        out.topBar = 'sun';
        break;
      case 'sunnyw':
        out.climacon = 'sun';
        out.topBar = 'wind';
        break;
      case 'tstorm':
        out.climacon = 'lighting cloud';
        out.topBar = 'rain';
        break;
      case 'tstorms':
        out.climacon = 'lighting cloud';
        out.topBar = 'rain';
        break;
      case 'tstormsw':
        out.climacon = 'lighting cloud';
        out.topBar = 'cloud';
        break;
      case 'windy':
        out.climacon = 'wind';
        out.topBar = 'wind';
        break;
      case 'wintrymix':
        out.climacon = 'sleet';
        out.topBar = 'rain';
        break;

      default:
        out.climacon = 'unknown';
        break;
    }

    if (!isDay) {
      out.climacon = out.climacon.split('sun').join('moon');
    }

    return out;
  }


  //   <ul class="week-forecast">
  //   <li class="sun">
  //      <div class="inner">
  //         <h5 class="week-day">Monday</h5>
  //         <i class="climacon sun"></i>
  //         <p class="week-day-temperature">30</p>
  //      </div>
  //   </li>
  //   <li class="rain">
  //      <div class="inner">
  //         <h5 class="week-day">Tuesday</h5>
  //         <i class="climacon rain"></i>
  //         <p class="week-day-temperature">25</p>
  //      </div>
  //   </li>
  //   <li class="cloud">
  //      <div class="inner">
  //         <h5 class="week-day">Weds</h5>
  //         <i class="climacon cloud"></i>
  //         <p class="week-day-temperature">32</p>
  //      </div>
  //   </li>
  //   <li class="sun">
  //      <div class="inner">
  //         <h5 class="week-day">Thursday</h5>
  //         <i class="climacon sun"></i>
  //         <p class="week-day-temperature">30</p>
  //      </div>
  //   </li>
  //   <li class="rain sun">
  //      <div class="inner">
  //         <h5 class="week-day">Friday</h5>
  //         <i class="climacon rain sun"></i>
  //         <p class="week-day-temperature">29</p>
  //      </div>
  //   </li>
  //   <li class="sun">
  //      <div class="inner">
  //         <h5 class="week-day">Saturday</h5>
  //         <i class="climacon sun"></i>
  //         <p class="week-day-temperature">25</p>
  //      </div>
  //   </li>
  //   <li class="cloud sun">
  //      <div class="inner">
  //         <h5 class="week-day">Sunday</h5>
  //         <i class="climacon cloud sun"></i>
  //         <p class="week-day-temperature">22</p>
  //      </div>
  //   </li>
  // </ul>

}



// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/designer.module/screen-elements.module/se-weather-multiday/se-weather-multiday.component.ts